import InfoPopout from "components/Wrappers/InfoPopout";
import { HIGHLIGHTS, ToolTypes, keyWordClassname} from "utils/ToolTipConst";
export default function PopText({
  recordName,
  recordType = "generic",
  children,
  text,
}: {
  recordName: string;
  text: string;
  recordType?: string;
  children?: React.ReactNode;
}) {

  var toolTipContent = ToolTypes[recordType][recordName] ?? (<div></div>);
  return (
    <span className={keyWordClassname}>
      {text}
      <InfoPopout
        maxWidth={400}
        popupContent={
          toolTipContent
        }
        delay={100}
      />
    </span>
  );
}
